import React from 'react'
import {Navigate } from 'react-router-dom'


function Forgotpassword() {

  const localStorageToken = localStorage.getItem("isLoggedIn");


  if(localStorageToken) return <Navigate to="/home"  replace />

  return (
    <div>Forgotpassword</div>
  )
}

export default Forgotpassword